import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Collapse from '@material-ui/core/Collapse'

import AccessTimeIcon from '@material-ui/icons/AccessTime'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import DateRangeIcon from '@material-ui/icons/DateRange'
import moment from 'moment'
import AsyncContainer from '../../../containers/Common/AsyncContainer'
import { Word } from '../../../containers';
import { WID, getWord } from '../../../constants/Language';

const DateTimePicker = AsyncContainer(() => import(/* webpackChunkName: "DateTimePicker" */  '@maven-io/material-ui-pickers/DateTimePicker')
  .then(module => module.default), { name: 'DateTimePicker' });

const styles = theme => ({
  thumbnail: {
    width: '100%',
  },
  formBox: {

  }
})

class EventTweetDialog extends React.Component {
  state = {
    text: '',
    datetime: null,
    checkedImage: true,
    twitterText: undefined,
  }

  componentDidMount() {
    import(/* webpackChunkName: "twitter-text" */ 'twitter-text').then(module => this.setState({ twitterText: module.default }))
  }

  handleEnter = () => {
    var lines
    const { record, language } = this.props
    lines = []
    lines.push(`${record.name}\n`)
    if (record.startDate) {
      if (record.startTime) {
        lines.push(`■ ${getWord(WID.EVENT_TWEET_DIALOG.DEFAULT_TEXT.DATETIME, language)}\n${moment(record.startDate + record.startTime).format('YYYY/MM/DD(ddd) HH:mm')}\n`)
      }
      else {
        lines.push(`■ ${getWord(WID.EVENT_TWEET_DIALOG.DEFAULT_TEXT.DATETIME, language)}\n${moment(record.startDate).format('YYYY/MM/DD(ddd)')}\n`)
      }
    }
    if (record.address) {
      lines.push(`■ ${getWord(WID.EVENT_TWEET_DIALOG.DEFAULT_TEXT.PLACE, language)}\n${record.address}\n`)
    }
    lines.push(`■ URL\nhttp://v1.renjuportal.com/event/${record.id}\n`)
    this.setState({ text: lines.join('\n'), datetime: null, checkedImage: true })
  }

  handleTweet = () => {
    const { handleTweet, onClose, record } = this.props
    const { text, datetime, checkedImage } = this.state
    if (handleTweet) {
      handleTweet(record, text, datetime, checkedImage)
    }
    if (onClose) {
      onClose()
    }
  }

  handleTextChange = (name) => (event) => {
    this.setState({ [name]: event.target.value })
  }
  
  handleChangedDateTime = (name) => (datetime) => {
    this.setState({ [name]: datetime })
  }

  handleChangedCheckbox = (name) => (event) => {
    this.setState({ [name]: event.target.checked })
  }

  render() {
    const { classes, open, onClose, record, language } = this.props
    const { text, datetime, checkedImage } = this.state
    var ret
    ret = this.state.twitterText !== undefined ? this.state.twitterText.parseTweet(text) : { weightedLength: 0, valid: true }
    return (
      <Dialog {...{ open, onClose, onEnter: this.handleEnter }}>
        <DialogTitle><Word wid={WID.EVENT_TWEET_DIALOG.DIALOG_TITLE}/></DialogTitle>
        <DialogContent>
          <TextField
            label={<Word wid={WID.EVENT_TWEET_DIALOG.TEXT}/>}
            margin='normal'
            rows='5'
            multiline
            fullWidth
            helperText={getWord(WID.EVENT_TWEET_DIALOG.REMAINING, language) + `: ${280 - ret.weightedLength}`}
            value={text}
            onChange={this.handleTextChange('text')}
            error={!ret.valid}
          />
          <DateTimePicker
            variant='body1'
            margin='normal'
            value={datetime}
            TextFieldComponent={TextField}
            leftArrowIcon={<KeyboardArrowLeftIcon/>}
            rightArrowIcon={<KeyboardArrowRightIcon/>}
            timeIcon={<AccessTimeIcon/>}
            dateRangeIcon={<DateRangeIcon/>}
            onChange={this.handleChangedDateTime('datetime')}
            clearable
            disablePast
            labelFunc={(date) => { return date !== null ? date.format('YYYY/MM/DD (ddd) HH:mm') : getWord(WID.EVENT_TWEET_DIALOG.IMMEDIATELY_POST, language) }}
            className={classes.datetimePicker}
            label={getWord(WID.EVENT_TWEET_DIALOG.DATETIME, language)}
          />
          {record.thumbnail && (
            <React.Fragment>
              <div className={classes.formBox}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedImage}
                      onChange={this.handleChangedCheckbox('checkedImage')}
                      color='primary'
                    />
                  }
                  label={getWord(WID.EVENT_TWEET_DIALOG.ATTACHMENT_THUMBNAIL)}
                />
              </div>
              <Collapse in={checkedImage}>
                <img className={classes.thumbnail} src={record.thumbnail} alt={record.id}/>
              </Collapse>
            </React.Fragment>
          )}
        </DialogContent>
        <DialogActions>
          <Button disabled={!ret.valid} variant='contained' color='primary' onClick={this.handleTweet}>
            {datetime ? getWord(WID.EVENT_TWEET_DIALOG.SCHEDULE_TWEET_BUTTON) : getWord(WID.EVENT_TWEET_DIALOG.SCHEDULE_TWEET_BUTTON)}
          </Button>
          <Button onClick={onClose}>{'Close'}</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles, { withTheme: true })(EventTweetDialog)


// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventTweetDialog.js